/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import setTestRanges from "../SetTestRangeModal/SetTestRanges.vue";
import VPagination from "@hennge/vue3-pagination";
import customModal from "../customModal/customModal.vue";
import assignTestModal from "./assignTestModal.vue";
import LabTestVersionModal from "./LabTestVersionModal.vue";
import SetTestVersionModal from "../SetTestVersionModal/SetTestVersionModal.vue";
// import labValidationRule from "../labValidationRule/labValidationRule.vue";

export default {
    name: "labTest",
    props: { id: String },
    components: {
        setTestRanges,
        customModal,
        assignTestModal,
        SetTestVersionModal,
        VPagination,
        LabTestVersionModal,
        
    },
    data() {
        return {
            showLoading: true,
            showLabPopup: false,
            showLabVersionPopup: false,
            selectedReferenceId: "",

            showValidationRule:false,
            labList: [],
            baseurl: process.env.VUE_APP_Service_URL,
            testName: "",
            category: "",
            testCode: "",
            passedunit:"",
            showSetVersion: false,
            selectedVersion: 0,
            token: "",
            pageNumber: 1,
            currentPageNumber: 1,
            SortOrder: 0,
            currentVersion: "",
            SortProperty: "",
            currentPage: 1,
            totalItems: 0,
            showSetRange: false,
            selectedLabCode: "",
            selectedTestCode: "",
            selectedRuleCode:"",
            selectedRuleName:"",
            enableNext: false,
            enablePrevious: false,
            studyId: store.getters.getStudyIs,
            PropsLabCode: "",
            cdiscVariable:""

        };
    },
    async mounted() {
        this.selectedLabCode = this.id;
        this.token = store.getters.getIdToken;
        await this.getLabTest();
    },
    methods: {
        async getLabTest() {
            this.showLoading = true;
            try {
                const response = await axios.get(
                    `${this.baseurl}/management/labtest/labtestassignedlist?StudyId=${this.studyId}&LabCode=${this.selectedLabCode}&pageIndex=${this.currentPage}&pageSize=1000&sortProperty=${this.SortProperty}&sortOrder=${this.SortOrder}`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.token,
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log("Assigned lab tests:", response.data);

                const assignedData = response.data?.assignedTests || response.data || {};

                this.labList = assignedData.results || [];
                this.totalItems = Math.ceil((assignedData.totalCount || 0) / 10);
            } catch (err) {
                console.error("Error fetching assigned lab test list:", err);
                this.labList = [];
            } finally {
                this.showLoading = false;
            }
        },

        async SearchButtonClicked() {
            this.pageNumber = 1;
            this.currentPageNumber = 1;
            this.searchData()
        },
        async openSetrangeModal(id, unit, cdiscVariable) {
            this.cdiscVariable = cdiscVariable;
            console.log("this.cdiscVariable = ",this.cdiscVariable);
          console.log("unit is", unit);
          this.passedunit = unit;
            this.selectedTestCode = id;
            this.showSetRange = true;
        },
        async closeSetRangeModal() {
            this.showSetRange = false;
        },
        assignTest() {
            this.PropsLabCode = this.selectedLabCode;
            this.showLabPopup = true;
        },
        async onclosed() {
            this.$router.push(`/labs`);
        },
        closeSetVersionModal() {
            this.showSetVersion = false;
        },
        closeValidation(){
          this.showValidationRule= false;
        },
        refreshLabTestList() {
            this.getLabTest();
        },

    openVersionModal(testCode) {
  this.selectedTestCode = testCode;
  this.PropsLabCode = this.selectedLabCode;

  // Assuming each test in labList includes currentVersion info:
  const selected = this.labList.find(l => l.testCode === testCode);
  this.selectedVersion = selected?.versionNo || ""; // adjust if versionNo field is named differently

  this.showLabVersionPopup = true;
},
  loadPage: function (page) {
      this.currentPage = page;
      this.pageindex = page;
      this.getLabTest();
    },
//   async openValidationModal(item) {
//   this.selectedTestCode = item.testCode;
//   this.selectedRuleName = item.ruleName;
//   this.selectedRuleCode = item.ruleCode;
//   this.showValidationRule = true;
// }




    },
};